module.exports = __webpack_public_path__ + "img/uk-events-1.4dbbe76f.png";